export const config = {
  apiBase: import.meta.env.VITE_API_BASE ?? '',
  wsBase: import.meta.env.VITE_WS_BASE ?? '',
  oidc: {
    authority: import.meta.env.VITE_OIDC_AUTHORITY ?? '',
    clientId: import.meta.env.VITE_OIDC_CLIENT_ID ?? '',
    redirectUri: import.meta.env.VITE_OIDC_REDIRECT_URI ?? `${window.location.origin}/auth/callback`,
    postLogoutRedirectUri: import.meta.env.VITE_OIDC_POST_LOGOUT_REDIRECT_URI ?? window.location.origin,
    scope: import.meta.env.VITE_OIDC_SCOPE ?? 'openid profile email',
    audience: import.meta.env.VITE_OIDC_AUDIENCE ?? '',
  },
};
